import { render, staticRenderFns } from "./itemSale.vue?vue&type=template&id=75578219&scoped=true&"
import script from "./itemSale.vue?vue&type=script&lang=js&"
export * from "./itemSale.vue?vue&type=script&lang=js&"
import style0 from "./itemSale.vue?vue&type=style&index=0&id=75578219&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75578219",
  null
  
)

export default component.exports